"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _react2 = require("@emotion/react");
var _globalStyles = _interopRequireDefault(require("./global-styles"));
const GlobalStyles = _ref => {
  let {
    myStyles
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_react2.Global, {
    styles: _globalStyles.default.concat(myStyles)
  });
};
var _default = exports.default = GlobalStyles;